export const sendInvitesUiConstaints = {
    SET_SEND_INVITES_OPEN: 'SET_SEND_INVITES_OPEN',
};
